import { SavedAdvancedFilter } from '@bits/ui';
import useSWR, { mutate } from 'swr';

type SavedFilters = {
  [key: string]: SavedAdvancedFilter[];
};

const filterStorage: SavedFilters = JSON.parse(
  (typeof localStorage !== 'undefined' &&
    localStorage.getItem(`saved-filters`)) ||
    '{}'
);

export const saveAdvancedFilters = (
  category: string,
  filters: SavedAdvancedFilter[]
) => {
  mutate(`saved-filters-${category}`, async () => {
    if (!filterStorage[category]) {
      filterStorage[category] = [];
    }
    filterStorage[category] = filters;
    localStorage.setItem(`saved-filters`, JSON.stringify(filterStorage));

    return filters;
  });
};

export const useSavedAdvancedFilters = (key?: string) => {
  return useSWR(key && `saved-filters-${key}`, async () => {
    return [...(filterStorage[key!] || [])];
  });
};
